/* eslint-disable no-unused-vars */
import React from "react";
import { Button } from "../../Components/ui/Button";
import { useNavigate } from "react-router-dom";
//
const PageNotFound = () => {
  const navigate = useNavigate();
  return (
    <div className="flex flex-col justify-center items-center h-screen">
      <div className="flex max-w-[360px] mx-auto ">
        <img
          src="/Assets/Images/404Page.png"
          alt="404_Page"
          className="w-full h-full object-contain"
        />
      </div>
      <Button onClick={() => navigate(-1)}>Previous Page</Button>
    </div>
  );
};

export default PageNotFound;
